import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ControlPanel from "../../controlPanel/controlPanel";

// ⬇️ Custom SVG Icons
import CreateIcon from "../../../assets/icons/folder-add.svg";
import ExploreIcon from "../../../assets/icons/element-3.svg";
import MessageIcon from "../../../assets/icons/message.svg";
import CommunitiesIcon from "../../../assets/icons/profile-2user.svg";
import SettingIcon from "../../../assets/icons/setting-2.svg";

const NavButtonsSection = ({ unreadMessagesCount, handleNavigation }) => {
  const location = useLocation();
  const [showControlPanel, setShowControlPanel] = useState(false);
   
  const navItems = [
    {
      label: "Explore",
      icon: <img src={ExploreIcon} alt="Explore" className="w-5 h-5" />,
    },
    {
      label: "Communities",
      icon: <img src={CommunitiesIcon} alt="Communities" className="w-5 h-5" />,
    },
    // {
    //   label: "Create",
    //   icon: <img src={CreateIcon} alt="Create" className="w-5 h-5" />,
    // },
    {
      label: "Messages",
      icon: <img src={MessageIcon} alt="Messages" className="w-5 h-5" />,
    },
  ];

  const isActive = (label) => {
    const path = location.pathname.toLowerCase();
    return path.includes(label.toLowerCase());
  };

  return (
    <>
      <div className="flex flex-col gap-4 font-inter mt-10 px-2 w-full">
        {navItems.map(({ label, icon }) => {
          const active = isActive(label);
          return (
            <button
              key={label}
              onClick={() => handleNavigation(label)}
              className={`relative flex items-center gap-3 px-4 py-2 w-full rounded-md text-left text-[16px] font-medium transition-all duration-200 ${
                active
                  ? "bg-blue-500/10 text-[#0787FF]"
                  : "text-black hover:text-[#0787FF]"
              }`}
            >
              {icon}
              <span className="flex-grow flex items-center gap-2">
                {label}
                {label === "Communities" && (
                  <span className="px-2 py-0.5 text-[10px] font-semibold bg-yellow-200 text-yellow-800 rounded-full">
                    Test
                  </span>
                )}
              </span>


              {label === "Messages" && unreadMessagesCount > 0 && (
                <span className="absolute -top-1 left-7 bg-red-600 text-white text-[10px] font-bold rounded-full px-1.5 py-[1px] animate-pulse">
                  {unreadMessagesCount > 9 ? "9+" : unreadMessagesCount}
                </span>
              )}
            </button>
          );
        })}

        {/* ⚙️ Settings Button */}
        <button
          onClick={() => setShowControlPanel(true)}
          className="flex items-center gap-3 px-4 py-2 w-full rounded-md text-left text-[16px] font-medium text-black hover:text-[#0787FF] transition-all duration-200"
        >
          <img src={SettingIcon} alt="Settings" className="w-5 h-5" />
          <span className="flex-grow">Settings</span>
        </button>
      </div>

      {showControlPanel && (
        <ControlPanel onClose={() => setShowControlPanel(false)} />
      )}
    </>
  );
};

export default NavButtonsSection;
